import { useSoftphone } from "@dialstack/sdk-react/softphone";
import { useState } from "react";

import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";

import {
  dtmfKeySx,
  dtmfReadoutSx,
  workbenchOverlaySx
} from "./dialstack-softphone-widget.styles";

type SoftphoneCall = ReturnType<typeof useSoftphone>["calls"][number];

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];

// The in-call keypad for phone menus ("press 2 for billing"): each key sends
// one DTMF digit down the call and echoes it in the readout. Replaces the
// SDK's keypad overlay, which lived inside its in-call screen (ENG-2226).
export default function DtmfKeypad({ call }: { call: SoftphoneCall }) {
  const { actions } = useSoftphone();
  const [typed, setTyped] = useState("");
  const send = (digit: string) => {
    actions.callActionsFor(call).sendDtmf(digit);
    setTyped((current) => (current + digit).slice(-24));
  };
  return (
    <Box data-testid="dtmf-keypad" sx={workbenchOverlaySx}>
      <Typography aria-live="polite" sx={dtmfReadoutSx}>
        {typed || "Keypad"}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 0.75,
          mt: 1
        }}
      >
        {KEYS.map((digit) => (
          <ButtonBase
            key={digit}
            aria-label={`Send ${digit}`}
            className="suno-phone-no-drag"
            onClick={() => send(digit)}
            sx={dtmfKeySx}
          >
            {digit}
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
}
